import React from 'react';
import { Skeleton, Tooltip } from '@mui/material';
import {
  ContentTooltiptLearningContinuumLevelMarkingInfo,
  useStyles
} from '../ContentTooltip/ContentTooltip';

const LevelMarkingInfo = ({
  size,
  lc,
  level,
  marking,
  isLoading,
  maxMarking,
  minMarking,
  onMarking = () => {},
  onContextMenu = () => {}
}) => {
  const classes = useStyles();
  if (isLoading) {
    return (
      <Skeleton
        style={{
          width: size + 1,
          height: size + 1
        }}
        variant='rectangular'
        className='rounded'
      />
    );
  }

  if (!marking.exists) {
    return (
      <div
        style={{
          width: size,
          height: size
        }}
        // children={marking?.markingValue}
        className='rounded cursor-not-allowed bg-lines flex items-center justify-center text-xs'
      />
    );
  }
  return (
    // <Tooltip
    //   arrow
    //   placement="top"
    //   id={`tooltip-guttman-chart-${marking.studentId}-${lc._id}-${level.levelId}-${level.gsId}`}
    //   title={
    //     <ContentTooltiptLearningContinuumLevelMarkingInfo
    //       lc={lc}
    //       level={level}
    //       marking={marking}
    //       currentCurriculum={currentCurriculum}
    //     />
    //   }
    //   classes={{ tooltip: classes.customWidthGuttmanChart }}
    // >
    <div
      id={`tooltip-guttman-chart-${marking.studentId}-${lc._id}-${level.levelId}-${level.gsId}`}
      style={{
        width: size,
        height: size,
        backgroundColor: marking.primaryColor,
        color: marking.secondaryColor
      }}
      className={classes.infoGuttmanChart}
      onContextMenu={(e) =>
        onContextMenu(e, {
          studentId: marking.studentId,
          lcId: lc._id,
          levelId: level.levelId,
          gsId: level.gsId,
          id: level.gsId,
          isLevel: true,
          completed: marking.completed
        })
      }
      onClick={() =>
        onMarking({
          studentId: marking.studentId,
          lcId: lc._id,
          levelId: level.levelId,
          gsId: level.gsId,
          id: level.gsId,
          isLevel: true,
          completed: marking.completed === minMarking?._id ? maxMarking._id : minMarking._id
        })
      }
    >
      {/* {String (marking.markingValue)} */}
      {/* {lc.ulId || 'main'} */}
    </div>
    // </Tooltip>
  );
};

export default LevelMarkingInfo;
